import { render, staticRenderFns } from "./MobileExitPopUp.vue?vue&type=template&id=fb4a8c14&scoped=true&"
import script from "./MobileExitPopUp.vue?vue&type=script&lang=js&"
export * from "./MobileExitPopUp.vue?vue&type=script&lang=js&"
import style0 from "./MobileExitPopUp.vue?vue&type=style&index=0&id=fb4a8c14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4a8c14",
  null
  
)

export default component.exports